module.exports = __webpack_public_path__ + "static/img/bg.88223bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/feature6/bg.jpg
// module id = Ziq7
// module chunks = 7